import React from 'react';
const SvgOdpThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 96 96" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M88 76H8V20h62l18 18v2z" />
      <path fill="#D14C32" d="M60 29.111c9.328 0 16.889 7.561 16.889 16.889H60V29.111z" />
      <path fill="#C8C8C8" d="M77 48c0 10.493-8.507 19-19 19s-19-8.507-19-19 8.507-19 19-19v19h19z" />
      <path fill="#949494" d="M70.001 18H6v60h84V38L70.001 18zM70 21l17 17H70V21zm18 55H8V20h60v20h20v36z" />
      <path
        fill="#C8C8C8"
        d="M14 65h18v2H14zM14 59h18v2H14zM14 53h18v2H14zM14 47h18v2H14zM14 41h18v2H14zM14 35h18v2H14zM14 29h18v2H14z"
      />
      <path fill="#FFF" d="M70 21l17 17H70z" />
      <linearGradient id="odp-thumbnail_svg__a" gradientUnits="userSpaceOnUse" x1={6} y1={48} x2={90} y2={48}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#odp-thumbnail_svg__a)" d="M68 18H6v60h84V38L70.001 18H68z" />
      <linearGradient id="odp-thumbnail_svg__b" gradientUnits="userSpaceOnUse" x1={78} y1={45.813} x2={78} y2={40.175}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#odp-thumbnail_svg__b)" d="M68 40h20v6H68z" />
      <linearGradient
        id="odp-thumbnail_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={67.592}
        y1={37.408}
        x2={78.471}
        y2={26.529}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#odp-thumbnail_svg__c)" d="M68 18H24v2h44v20h20v38h2V38L70.001 18H68zm2 20V21l17 17H70z" />
    </svg>
  );
});
export default SvgOdpThumbnail;
SvgOdpThumbnail.iconName = 'odp-thumbnail';
SvgOdpThumbnail.displayName = 'SvgOdpThumbnail';
